import React, {Component} from 'react'
import {PasswordGenerator} from './Components/Container'
import { BrowserRouter as Router, Route , Redirect} from 'react-router-dom'
import queryString from 'query-string'
import {injectGlobal} from 'styled-components'
import WidgetBuilder from './Components/Container/Templates/WidgetBuilder'
import styled from 'styled-components'
import ResizeObserver from 'react-resize-observer'

class App extends Component {
    constructor (props) {
        super(props)
        this.state = {
        }
    }

    render () {
        const parsedQueries = window.location.search
            ? JSON.parse(JSON.stringify(queryString.parse(window.location.search))) // JSON parse for native json functions such as hasownproperty
            : {}

        if (parsedQueries.hasOwnProperty('hostname') && parsedQueries.hasOwnProperty('pathname')) {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                'event': 'GAEvent',
                'eventCategory': 'source',
                'eventAction': parsedQueries.hostname,
                'eventLabel': parsedQueries.pathname,
                'eventValue': '1',
            });
        }

        return (
            <Router>
                <ResizeWrapper>
                    <ResizeObserver onResize={rect => window.parent.postMessage({'height': rect.height}, '*')}/>
                    <Route
                        exact
                        path={'/'}
                        render={routeProps => <PasswordGenerator {...routeProps} {...parsedQueries}/>}/>
                    <Route
                        path={'/builder'}
                        render={routeProps => <WidgetBuilder {...routeProps}/>}/>
                </ResizeWrapper>
            </Router>
        );
    }
}

export default App

const ResizeWrapper = styled.div`
    position: relative;
`

injectGlobal`
    /* open-sans-300 - latin */
    @font-face {
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 300;
      font-display: optional;
      src: url('/fonts/open-sans-v15-latin-300.eot'); /* IE9 Compat Modes */
      src: local('Open Sans Light'), local('OpenSans-Light'),
           url('/fonts/open-sans-v15-latin-300.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
           url('/fonts/open-sans-v15-latin-300.woff2') format('woff2'), /* Super Modern Browsers */
           url('/fonts/open-sans-v15-latin-300.woff') format('woff'), /* Modern Browsers */
           url('/fonts/open-sans-v15-latin-300.ttf') format('truetype'), /* Safari, Android, iOS */
           url('/fonts/open-sans-v15-latin-300.svg#OpenSans') format('svg'); /* Legacy iOS */
    }
    /* open-sans-regular - latin */
    @font-face {
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 400;
      font-display: optional;
      src: url('/fonts/open-sans-v15-latin-regular.eot'); /* IE9 Compat Modes */
      src: local('Open Sans Regular'), local('OpenSans-Regular'),
           url('/fonts/open-sans-v15-latin-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
           url('/fonts/open-sans-v15-latin-regular.woff2') format('woff2'), /* Super Modern Browsers */
           url('/fonts/open-sans-v15-latin-regular.woff') format('woff'), /* Modern Browsers */
           url('/fonts/open-sans-v15-latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */
           url('/fonts/open-sans-v15-latin-regular.svg#OpenSans') format('svg'); /* Legacy iOS */
    }
    /* open-sans-700 - latin */
    @font-face {
      font-family: 'Open Sans';
      font-style: normal;
      font-weight: 700;
      font-display: optional;
      src: url('/fonts/open-sans-v15-latin-700.eot'); /* IE9 Compat Modes */
      src: local('Open Sans Bold'), local('OpenSans-Bold'),
           url('/fonts/open-sans-v15-latin-700.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
           url('/fonts/open-sans-v15-latin-700.woff2') format('woff2'), /* Super Modern Browsers */
           url('/fonts/open-sans-v15-latin-700.woff') format('woff'), /* Modern Browsers */
           url('/fonts/open-sans-v15-latin-700.ttf') format('truetype'), /* Safari, Android, iOS */
           url('/fonts/open-sans-v15-latin-700.svg#OpenSans') format('svg'); /* Legacy iOS */
    }
    body {
        -webkit-tap-highlight-color: rgba(0,0,0,0);
        font-family: 'Open Sans', sans-serif;
        margin: 0;
    }
    .hidden-mobile {
        @media(max-width:767px){
            display: none;
        }
    }
`



// WEBPACK FOOTER //
// ./src/jsx/App.jsx